export const ITALY_TRIVIA_ID = 1;
export const DEFAULT_TRIVIA_SLUG = "culinary-adventure-to-greece";

export const TRIVIA_LEADERBOARD_TOP_LIMIT = 10;

export enum ApiRoutes {
  SESSION = "/api/session",
  SESSION_EXISTS = "/api/auth/session/exists",
  PLAYERS = "/api/player",
  QUESTIONS = "/api/trivia/questions",
  ANSWERS = "/api/trivia/answers",
  TRIVIA_LEADERBOARDS = "/api/trivia/leaderboard/{id}",
  TRIVIA_SESSION_RESTART = "/api/trivia/session/restart",
  TRIVIA_SESSION_LEVEL_RESTART = "/api/trivia/level/reset",
  TRIVIA_SESSION_LEVEL_RESETS = "/api/trivia/level/resets/{id}",
  TRIVIA_SESSION_CREATE = "/api/trivia/session/create",
  TRIVIA_SESSION_PLAYER_RESTART_COUNT = "/api/trivia/session/player/restart/count",
  MAGIC_LINKS_VERIFY = "/api/guest-login/verify",
  MAGIC_LINKS_GENERATE = "/api/guest-login/generate",
}

export enum BackendRoutes {
  ANSWERS = "/answers",
  PLAYERS = "/players",
  PLAYER_TRIVIA_CONFIG = "/players/{playerId}/trivias/{triviaId}/config",
  QUESTIONS = "/questions",
  TRIVIA_LEADERBOARDS = "/leaderboards",
  TRIVIA_SESSION_RESTART = "/trivia-sessions/{id}/restart",
  TRIVIA_SESSION_LEVEL_RESTART = "/trivia-session-levels/{id}/reset",
  TRIVIA_SESSION_LEVEL_RESETS = "/trivia-session-levels/{id}/resets",
  TRIVIA_SESSIONS = "/trivia-sessions",
  TRIVIA_SESSION_PLAYER_RESTART_COUNT = "/trivia-sessions/players/{playerId}/restarts",
  TRIVIA = "/trivias/{id}",
  MAGIC_LINKS_GENERATE = "/magic-links/generate",
  MAGIC_LINKS_VERIFY = "/magic-links/verify",
  TEST_MAGIC_LINKS_VERIFY = "/magic-links/test-event",
  TRIVIA_BY_SLUG = "/trivias/slug/{slug}",
}
